module.exports = __webpack_public_path__ + "img/contract-savings.973a2ebf.svg";